(() => {
  'use strict';

  if (window.__mspNewsletterAttributionLoaded) return;
  window.__mspNewsletterAttributionLoaded = true;

  const script = document.currentScript
    || document.querySelector('script[src*="newsletter-attribution.js"]');
  const attributionKey = 'msp-newsletter-attribution-v1';
  const pendingKey = 'msp-newsletter-pending-v1';
  const lifetimeMs = 30 * 24 * 60 * 60 * 1000;
  const trackedParameters = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'gclid',
    'fbclid'
  ];

  const readJson = (storage, key) => {
    try {
      return JSON.parse(storage.getItem(key) || 'null');
    } catch (error) {
      return null;
    }
  };

  const writeJson = (storage, key, value) => {
    try {
      storage.setItem(key, JSON.stringify(value));
    } catch (error) {}
  };

  const cleanTagPart = (value) => String(value || '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 60);

  const currentAttribution = () => {
    const url = new URL(window.location.href);
    const hasCampaignParameters = trackedParameters.some((name) => url.searchParams.has(name));
    const stored = readJson(window.localStorage, attributionKey);

    if (!hasCampaignParameters && stored?.expiresAt > Date.now()) return stored;

    const source = url.searchParams.get('utm_source')
      || (url.searchParams.has('gclid') ? 'google' : '')
      || (url.searchParams.has('fbclid') ? 'facebook' : '')
      || 'direct';
    const attribution = {
      capturedAt: Date.now(),
      expiresAt: Date.now() + lifetimeMs,
      landingPath: window.location.pathname,
      source,
      medium: url.searchParams.get('utm_medium') || '',
      campaign: url.searchParams.get('utm_campaign') || '',
      content: url.searchParams.get('utm_content') || '',
      term: url.searchParams.get('utm_term') || '',
      hasGoogleClickId: url.searchParams.has('gclid'),
      hasMetaClickId: url.searchParams.has('fbclid')
    };

    if (hasCampaignParameters) writeJson(window.localStorage, attributionKey, attribution);
    return attribution;
  };

  const addCustomerTags = (form, formId, attribution) => {
    const field = form.querySelector('input[name="contact[tags]"]');
    if (!field) return;

    const tags = new Set(field.value.split(',').map((tag) => tag.trim()).filter(Boolean));
    tags.add('newsletter');
    tags.add(`newsletter-form-${cleanTagPart(formId)}`);
    tags.add(`newsletter-source-${cleanTagPart(attribution.source || 'direct')}`);
    if (attribution.campaign) {
      tags.add(`newsletter-campaign-${cleanTagPart(attribution.campaign)}`);
    }
    field.value = Array.from(tags).join(',');
  };

  const publishSignup = (formId, attribution, eventId) => {
    const dedupeKey = `msp-newsletter-tracked:${eventId}`;
    try {
      if (window.sessionStorage.getItem(dedupeKey) === 'true') return;
      window.sessionStorage.setItem(dedupeKey, 'true');
    } catch (error) {}

    const parameters = {
      method: 'email',
      form_id: formId,
      signup_source: attribution.source || 'direct',
      signup_medium: attribution.medium || '(none)',
      signup_campaign: attribution.campaign || '(none)',
      signup_content: attribution.content || '(none)',
      landing_page: attribution.landingPath || window.location.pathname,
      page_type: script?.dataset.pageType || 'unknown',
      product_id: script?.dataset.productId || '(none)',
      google_click_id_present: attribution.hasGoogleClickId ? 'true' : 'false',
      meta_click_id_present: attribution.hasMetaClickId ? 'true' : 'false'
    };

    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function gtag() { window.dataLayer.push(arguments); };
    window.gtag('event', 'newsletter_signup', parameters);

    const googleAdsSendTo = script?.dataset.googleAdsSendTo
      || 'AW-11464714388/KmUjCOPdhoIdEJTR5toq';
    if (googleAdsSendTo) {
      window.gtag('event', 'conversion', {
        send_to: googleAdsSendTo,
        transaction_id: eventId
      });
    }

    if (typeof window.fbq === 'function') {
      window.fbq('track', 'Lead', {
        content_name: 'Newsletter Signup',
        content_category: formId
      }, { eventID: eventId });
    }

    if (window.Shopify?.analytics?.publish) {
      window.Shopify.analytics.publish('newsletter_signup', parameters);
    }
  };

  const initialize = () => {
    const attribution = currentAttribution();
    const registrations = [];
    const seenForms = new Set();

    const addRegistration = (form, formId, success) => {
      if (!form || seenForms.has(form)) return;
      seenForms.add(form);
      registrations.push({ form, formId, success });
    };

    document.querySelectorAll('[data-newsletter-attribution]').forEach((marker) => {
      const form = marker.closest('form');
      addRegistration(
        form,
        marker.dataset.newsletterFormId || form?.id || 'newsletter',
        marker.dataset.newsletterSignupSuccess === 'true'
      );
    });

    const freeShippingForm = document.querySelector('#FreeShippingSignupForm');
    const freeShippingRoot = document.querySelector('[data-free-shipping-signup]');
    addRegistration(
      freeShippingForm,
      'free-shipping-signup',
      freeShippingRoot?.dataset.signupSuccess === 'true'
    );

    const subscribeForm = document.querySelector('.subscribe__form');
    addRegistration(
      subscribeForm,
      'subscribe-band',
      Boolean(subscribeForm?.querySelector('.subscribe__success'))
    );

    const emailBannerForm = document.querySelector('.msp-mailband__form');
    addRegistration(
      emailBannerForm,
      'email-banner',
      Boolean(emailBannerForm?.querySelector('.msp-mailband__ok'))
    );

    registrations.forEach(({ form, formId, success }) => {
      form.addEventListener('submit', () => {
        const latestAttribution = currentAttribution();
        addCustomerTags(form, formId, latestAttribution);
        writeJson(window.sessionStorage, pendingKey, {
          formId,
          attribution: latestAttribution,
          eventId: `newsletter-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`
        });
      });

      if (!success) return;

      const pending = readJson(window.sessionStorage, pendingKey);
      const eventId = pending?.formId === formId
        ? pending.eventId
        : `newsletter-${formId}-${window.location.pathname}`;
      publishSignup(formId, pending?.attribution || attribution, eventId);

      try {
        window.sessionStorage.removeItem(pendingKey);
      } catch (error) {}
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
